var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"modal-footer"},[_vm._t("default"),_c('CancelButton',{attrs:{"label":_vm.props.cancelLabel}}),_c('SaveButton',{attrs:{"danger":_vm.props.danger,"disabled":!_vm.props.canSave,"loading":_vm.props.saving,"label":_vm.props.saveLabel}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }